import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component/umpire-component';
import {UmpireImage} from '../umpire-image';

export enum UmpireComponentBrandingThemeEnum {
  gray = 'ThemeGrey-Smart',
  black = 'ThemeBlack-Smart',
}

export interface UmpireComponentBranding
  extends UmpireComponent<UmpireComponentTypeEnum.BRANDING> {
  logo: UmpireImage | null;
  favicon: UmpireImage | null;
  meta_image: UmpireImage | null;
  theme_accent: string;
  page_title: string;
  theme: UmpireComponentBrandingThemeEnum;
}
